import React from 'react'
import PropTypes from 'prop-types'

import { Card } from 'semantic-ui-react'

import RugCard from 'Components/RugCard'

import * as styles from './styles'

const GridLayout = props => {
  const { enablePreview, fromPage, rugs, searchForm, togglePreview } = props

  const mappedCards = rugs.map((rug, i) => (
    <RugCard
      enablePreview={enablePreview}
      fromPage={fromPage}
      index={i}
      key={rug.id}
      picture={rug.picture}
      rug={rug}
      togglePreview={togglePreview}
    />
  ))

  return (
    <Card.Group itemsPerRow={searchForm ? 4 : 6} stackable style={styles.cardGroupStyle}>
      {mappedCards}
    </Card.Group>
  )
}

GridLayout.propTypes = {
  enablePreview: PropTypes.bool,
  fromPage: PropTypes.string,
  rugs: PropTypes.array.isRequired,
  searchForm: PropTypes.bool.isRequired,
  togglePreview: PropTypes.func,
}

GridLayout.defaultProps = {
  enablePreview: false,
  fromPage: 'search',
}

export default GridLayout
